import { useEventContext } from '../../contexts/EventContext';
import { useEventDetails } from '../../../hooks/useEventDetails';
import { SchedulePage } from './SchedulePage';
import { SchedulePageV1 } from '../../v1/components/schedule/SchedulePageV1';

/**
 * SchedulePageWrapper - ROUTING ONLY
 * 
 * This component's ONLY responsibility is to determine which
 * schedule component to render based on event type.
 * 
 * NO OTHER LOGIC should be added to this component.
 * NO props should be passed between components.
 * NO shared state or utilities.
 */
export const SchedulePageWrapper = () => {
  const { eventSlug } = useEventContext();
  const { data: eventDetails } = useEventDetails(eventSlug);
  
  // ONLY routing decision
  if (eventDetails?.isV1Event) {
    return <SchedulePageV1 />;
  }
  
  return <SchedulePage />;
};